import { publicCaseStudies } from '@/data/caseStudiesData';

// ===============================================
// SEO ENTERPRISE ROUTES CONFIGURATION
// Independent URLs per language with /en/ prefix
// Optimized for LLMs and multi-level positioning
// ===============================================

const BASE_URL = 'https://luisroc.com';

// ===== SPANISH ROUTES (Primary - Root) =====
export const esRoutes = {
  // Core Pages
  home: '/',
  about: '/sobre-mi',
  services: '/servicios',
  caseStudies: '/casos-de-exito',
  methodology: '/metodologia',
  seoDiagnosis: '/diagnostico-seo-gratis',
  seoTools: '/herramientas-seo',
  contact: '/contacto',
  faq: '/preguntas-frecuentes',
  booking: '/agendar-consultoria',
  officialInfo: '/informacion-oficial',
  transitionRequest: '/transicion-agencia',
  blog: '/blog',
  
  // Legal Pages
  terms: '/terminos-de-servicio',
  privacy: '/politica-de-privacidad',
  cookies: '/politica-de-cookies',
  disclaimer: '/aviso-legal',
  
  // Service Pages (Hub-Spoke)
  serviceAudit: '/servicios/seo-diagnostico',
  serviceSeoSem: '/servicios/seo-sem-estrategias',
  serviceGoogleAds: '/servicios/google-ads',
  serviceLlm: '/servicios/posicionamiento-llm',
  serviceAmazon: '/servicios/amazon-consulting',
  serviceRebranding: '/servicios/rebranding-seo',
  serviceBranding: '/servicios/branding',
  serviceWebsiteRedesign: '/servicios/rediseno-web',
  serviceContent: '/servicios/contenido-conversion',
  serviceTechnical: '/servicios/seo-tecnico',
  serviceConsultant: '/consultor-seo',
  serviceInternational: '/servicios/seo-internacional',
  serviceHispanic: '/servicios/seo-bilingue-mercado-hispano',
  serviceEcommerce: '/servicios/ecommerce-seo',

  // Search Library (P3)
  library: '/biblioteca',
  libraryAuditVsStrategy: '/biblioteca/auditoria-seo-o-estrategia-seo',
  libraryTechnicalPrioritization: '/biblioteca/priorizacion-seo-tecnico',
  librarySeoForAiSearch: '/biblioteca/seo-para-ai-search',
  libraryGeoAeoAiSeo: '/biblioteca/geo-aeo-y-ai-seo',
  libraryKeywordsInternational: '/biblioteca/traducir-keywords-no-es-seo-internacional',
  libraryHispanicMarket: '/biblioteca/seo-mercado-hispano-estados-unidos',
  libraryCategoryVsProduct: '/biblioteca/ecommerce-categorias-vs-productos',
  libraryAmazonSeoVsAds: '/biblioteca/amazon-seo-vs-amazon-ads',
  libraryConsultantVsAgency: '/biblioteca/consultor-seo-o-agencia-seo',
  
  // Local SEO Hubs
  localSeoHub: '/seo-local',
  localHubHouston: '/servicios-locales-houston',
  localHubFlorida: '/servicios-locales-florida',
  localSeoHouston: '/seo-local-houston',
  
  // High-Intent Landing Pages
  googleAdsHoustonEs: '/publicidad-google-ads-houston',
  googleAdsLawyersEs: '/google-ads-abogados-texas',
  
  // Tools (15 specialized pages)
  toolMega: '/herramientas/seo-mega-tool',
  toolWordCounter: '/herramientas/contador-palabras',
  toolSitemap: '/herramientas/generador-sitemap',
  toolSpellCheck: '/herramientas/corrector-ortografico',
  toolBlacklist: '/herramientas/verificador-blacklist',
  toolGmb: '/herramientas/analizador-seo-local-gmb',
  toolPenalty: '/herramientas/analizador-penalizaciones-google',
  toolMeta: '/herramientas/generador-metatags',
  toolUrl: '/herramientas/analizador-url',
  toolDensity: '/herramientas/densidad-palabras',
  toolContent: '/herramientas/generador-contenido',
  toolChatbot: '/herramientas/chatbot-personalizado',
  toolImages: '/herramientas/generador-imagenes',
  toolCode: '/herramientas/asistente-codigo',
  toolSentiment: '/herramientas/analizador-sentimientos',
};

// ===== ENGLISH ROUTES (Secondary - /en/ prefix) =====
export const enRoutes = {
  // Core Pages
  home: '/en',
  about: '/en/about',
  services: '/en/services',
  caseStudies: '/en/case-studies',
  methodology: '/en/methodology',
  seoDiagnosis: '/en/free-seo-diagnosis',
  seoTools: '/en/seo-tools',
  contact: '/en/contact',
  faq: '/en/faq',
  booking: '/en/book-consultation',
  officialInfo: '/en/official-information',
  transitionRequest: '/en/transition-request',
  blog: '/en/blog',
  
  // Legal Pages
  terms: '/en/terms-of-service',
  privacy: '/en/privacy-policy',
  cookies: '/en/cookies-policy',
  disclaimer: '/en/disclaimer',
  
  // Service Pages (Hub-Spoke)
  serviceAudit: '/en/services/seo-audit',
  serviceSeoSem: '/en/services/seo-sem-strategies',
  serviceGoogleAds: '/en/services/google-ads',
  serviceLlm: '/en/services/llm-positioning',
  serviceAmazon: '/en/services/amazon-consulting',
  serviceRebranding: '/en/services/rebranding-seo',
  serviceBranding: '/en/services/branding',
  serviceWebsiteRedesign: '/en/services/website-redesign',
  serviceContent: '/en/services/content-conversion',
  serviceTechnical: '/en/services/technical-seo',
  serviceConsultant: '/en/seo-consultant',
  serviceInternational: '/en/services/international-seo',
  serviceHispanic: '/en/services/hispanic-market-seo',
  serviceEcommerce: '/en/services/ecommerce-seo',

  // Search Library (P3)
  library: '/en/library',
  libraryAuditVsStrategy: '/en/library/seo-audit-vs-seo-strategy',
  libraryTechnicalPrioritization: '/en/library/technical-seo-prioritization',
  librarySeoForAiSearch: '/en/library/seo-for-ai-search',
  libraryGeoAeoAiSeo: '/en/library/geo-aeo-and-ai-seo',
  libraryKeywordsInternational: '/en/library/translating-keywords-is-not-international-seo',
  libraryHispanicMarket: '/en/library/seo-us-hispanic-market',
  libraryCategoryVsProduct: '/en/library/ecommerce-category-vs-product-pages',
  libraryAmazonSeoVsAds: '/en/library/amazon-seo-vs-amazon-advertising',
  libraryConsultantVsAgency: '/en/library/seo-consultant-vs-seo-agency',
  
  // Local SEO Hubs
  localSeoHub: '/en/local-seo',
  localHubHouston: '/en/local-services-houston',
  localHubFlorida: '/en/local-services-florida',
  localSeoHouston: '/en/local-seo-houston',
  
  // High-Intent Landing Pages
  // Nota (P4): las landings de Google Ads en inglés viven en la raíz
  // (`/google-ads-advertising-houston`, `/google-ads-lawyers-texas`), no bajo
  // `/en/`. Las variantes `/en/...` nunca existieron como página: se retiran
  // del inventario para no generar 404 en sitemap ni en enlaces internos.

  
  // Tools (15 specialized pages)
  toolMega: '/en/tools/seo-mega-tool',
  toolWordCounter: '/en/tools/word-counter',
  toolSitemap: '/en/tools/sitemap-generator',
  toolSpellCheck: '/en/tools/spell-checker',
  toolBlacklist: '/en/tools/blacklist-checker',
  toolGmb: '/en/tools/local-seo-gmb-analyzer',
  toolPenalty: '/en/tools/google-penalization-analyzer',
  toolMeta: '/en/tools/meta-tags-generator',
  toolUrl: '/en/tools/url-analyzer',
  toolDensity: '/en/tools/keyword-density',
  toolContent: '/en/tools/ai-content-generator',
  toolChatbot: '/en/tools/custom-chatbot',
  toolImages: '/en/tools/ai-image-generator',
  toolCode: '/en/tools/code-assistant',
  toolSentiment: '/en/tools/sentiment-analyzer',
};

// ===== LOCATION PAGES (Texas & Florida) =====
export const locationRoutes = {
  // Texas Cities - SEO
  seoHouston: '/seo-houston',
  seoSpring: '/seo-spring',
  seoConroe: '/seo-conroe',
  seoKaty: '/seo-katy',
  seoSugarLand: '/seo-sugar-land',
  seoTomball: '/seo-tomball',
  seoMagnolia: '/seo-magnolia',
  seoMemorial: '/seo-memorial',
  seoWoodlands: '/seo-the-woodlands',
  
  // Texas Cities - Google Ads
  adsHouston: '/google-ads-houston',
  adsSpring: '/google-ads-spring',
  adsConroe: '/google-ads-conroe',
  adsKaty: '/google-ads-katy',
  adsSugarLand: '/google-ads-sugar-land',
  adsTomball: '/google-ads-tomball',
  adsMagnolia: '/google-ads-magnolia',
  adsMemorial: '/google-ads-memorial',
  adsWoodlands: '/google-ads-the-woodlands',
  
  // The Woodlands Specialized
  brandingWoodlands: '/branding-web-the-woodlands',
  ecommerceWoodlands: '/ecommerce-marketplaces-the-woodlands',
  socialWoodlands: '/social-media-marketing-the-woodlands',
  
  // Florida Cities
  seoOrlando: '/seo-orlando',
  adsOrlando: '/google-ads-orlando',
  seoMiami: '/seo-miami',
  adsMiami: '/google-ads-miami',
};

// ===== ALL PUBLIC ROUTES FOR SITEMAP & PRERENDERING =====
export const publicRoutes = [
  // Spanish Core
  ...Object.values(esRoutes),
  
  // English Core (with /en/ prefix)
  ...Object.values(enRoutes),
  
  // Location Pages (bilingual by content - no prefix needed)
  ...Object.values(locationRoutes),
  
  // High-intent landing pages
  '/publicidad-google-ads-houston',
  '/google-ads-abogados-texas',
];

// ===== P3 QUALITY GATE: NOINDEX PROVISIONAL =====
// Herramientas que hoy NO producen un resultado real (BUILD_CANDIDATE,
// GUIDE_CONVERSION_CANDIDATE, LOW_VALUE_TOOL, BROKEN_TOOL en SEO-TOOLS-AUDIT.md).
// La URL se conserva: solo se retira del índice y del sitemap.
export const noindexToolRoutes: string[] = [
  esRoutes.toolMega, enRoutes.toolMega,
  esRoutes.toolSitemap, enRoutes.toolSitemap,
  esRoutes.toolSpellCheck, enRoutes.toolSpellCheck,
  esRoutes.toolBlacklist, enRoutes.toolBlacklist,
  esRoutes.toolGmb, enRoutes.toolGmb,
  esRoutes.toolPenalty, enRoutes.toolPenalty,
  esRoutes.toolContent, enRoutes.toolContent,
  esRoutes.toolChatbot, enRoutes.toolChatbot,
  esRoutes.toolImages, enRoutes.toolImages,
  esRoutes.toolCode, enRoutes.toolCode,
  esRoutes.toolSentiment, enRoutes.toolSentiment,
];

// Rutas legales ES que sirven el documento legal en inglés: no son una
// traducción real (LEGAL_TRANSLATION_REQUIRED). Se canonicalizan hacia el
// documento inglés equivalente y salen del índice y del sitemap.
export const legalEsAwaitingTranslation: Record<string, string> = {
  [esRoutes.terms]: enRoutes.terms,
  [esRoutes.privacy]: enRoutes.privacy,
  [esRoutes.cookies]: enRoutes.cookies,
  [esRoutes.disclaimer]: enRoutes.disclaimer,
};

// Rutas listadas en el inventario que hoy no resuelven a una página real
// (renderizan 404). P4: las dos entradas históricas (`/en/google-ads-*`) eran
// un error de inventario, no URLs reales; se han retirado del listado de
// `enRoutes`. La lista se conserva vacía como punto de control.
export const unroutedRoutes: string[] = [];

// Duplicados canonicalizados: sirven el mismo contenido que su canónica
// (landings de Google Ads y páginas /en/ que todavía sirven el texto en
// español). Siguen accesibles y con canonical hacia el original, pero no se
// envían en el sitemap para no pedir indexación de duplicados.
// P4: `/en/services/{google-ads,seo-sem-strategies,rebranding-seo,
// content-conversion}` salen de esta lista porque ya tienen versión inglesa
// real, canonical autorreferencial y hreflang recíproco.
// Fase 3: las cuatro rutas `/en/local-*` también salen. Servían español porque
// el idioma venía de `useState('es')` en la página, no de la URL; ahora se
// deriva de la ruta y renderizan el contenido inglés que ya existía en los
// componentes.
export const canonicalizedDuplicateRoutes: string[] = [
  '/publicidad-google-ads-houston',
  '/google-ads-abogados-texas',
  // Landings con slug inglés que todavía sirven el contenido ES equivalente.
  '/google-ads-advertising-houston',
  '/google-ads-lawyers-texas',
  // El formulario de transición en /en todavía se sirve en español.
  '/en/transition-request',
];


export const noindexRoutes: string[] = [
  ...noindexToolRoutes,
  ...Object.keys(legalEsAwaitingTranslation),
  ...unroutedRoutes,
];

export const isNoindexRoute = (path: string): boolean =>
  noindexRoutes.includes(path.length > 1 ? path.replace(/\/+$/, '') : path);

/** URLs que queremos que los buscadores descubran (no es el inventario de rutas). */
export const sitemapRoutes = publicRoutes.filter(
  (route) =>
    typeof route === 'string' &&
    !noindexRoutes.includes(route) &&
    !canonicalizedDuplicateRoutes.includes(route)
);


// ===== EXCLUDED ROUTES (Protected/Dynamic) =====
export const excludedRoutes = [
  '/auth',
  '/admin',
  '/admin-setup',
  '/dashboard',
  '/payment-success',
  '/gallery-admin',
];


// ===== COMPREHENSIVE LANGUAGE MAPPING =====
export const routeLanguageMap: Record<string, { es: string; en: string }> = {
  // Core Pages
  '/': { es: '/', en: '/en' },
  '/en': { es: '/', en: '/en' },
  '/sobre-mi': { es: '/sobre-mi', en: '/en/about' },
  '/en/about': { es: '/sobre-mi', en: '/en/about' },
  '/servicios': { es: '/servicios', en: '/en/services' },
  '/en/services': { es: '/servicios', en: '/en/services' },
  '/casos-de-exito': { es: '/casos-de-exito', en: '/en/case-studies' },
  '/en/case-studies': { es: '/casos-de-exito', en: '/en/case-studies' },
  '/metodologia': { es: '/metodologia', en: '/en/methodology' },
  '/en/methodology': { es: '/metodologia', en: '/en/methodology' },
  '/diagnostico-seo-gratis': { es: '/diagnostico-seo-gratis', en: '/en/free-seo-diagnosis' },
  '/en/free-seo-diagnosis': { es: '/diagnostico-seo-gratis', en: '/en/free-seo-diagnosis' },
  '/herramientas-seo': { es: '/herramientas-seo', en: '/en/seo-tools' },
  '/en/seo-tools': { es: '/herramientas-seo', en: '/en/seo-tools' },
  '/contacto': { es: '/contacto', en: '/en/contact' },
  '/en/contact': { es: '/contacto', en: '/en/contact' },
  '/preguntas-frecuentes': { es: '/preguntas-frecuentes', en: '/en/faq' },
  '/en/faq': { es: '/preguntas-frecuentes', en: '/en/faq' },
  '/agendar-consultoria': { es: '/agendar-consultoria', en: '/en/book-consultation' },
  '/en/book-consultation': { es: '/agendar-consultoria', en: '/en/book-consultation' },
  // /en/transition-request redirige 301 a la versión ES: sin par hreflang
  // hasta que exista contenido inglés real.
  '/transicion-agencia': { es: '/transicion-agencia', en: '/transicion-agencia' },
  '/blog': { es: '/blog', en: '/en/blog' },
  '/en/blog': { es: '/blog', en: '/en/blog' },
  
  // Legal Pages
  '/terminos-de-servicio': { es: '/terminos-de-servicio', en: '/en/terms-of-service' },
  '/en/terms-of-service': { es: '/terminos-de-servicio', en: '/en/terms-of-service' },
  '/politica-de-privacidad': { es: '/politica-de-privacidad', en: '/en/privacy-policy' },
  '/en/privacy-policy': { es: '/politica-de-privacidad', en: '/en/privacy-policy' },
  '/politica-de-cookies': { es: '/politica-de-cookies', en: '/en/cookies-policy' },
  '/en/cookies-policy': { es: '/politica-de-cookies', en: '/en/cookies-policy' },
  '/informacion-oficial': { es: '/informacion-oficial', en: '/en/official-information' },
  '/en/official-information': { es: '/informacion-oficial', en: '/en/official-information' },
  '/aviso-legal': { es: '/aviso-legal', en: '/en/disclaimer' },
  '/en/disclaimer': { es: '/aviso-legal', en: '/en/disclaimer' },
  
  // Service Pages
  '/servicios/seo-diagnostico': { es: '/servicios/seo-diagnostico', en: '/en/services/seo-audit' },
  '/en/services/seo-audit': { es: '/servicios/seo-diagnostico', en: '/en/services/seo-audit' },
  '/servicios/seo-sem-estrategias': { es: '/servicios/seo-sem-estrategias', en: '/en/services/seo-sem-strategies' },
  '/en/services/seo-sem-strategies': { es: '/servicios/seo-sem-estrategias', en: '/en/services/seo-sem-strategies' },
  '/servicios/google-ads': { es: '/servicios/google-ads', en: '/en/services/google-ads' },
  '/en/services/google-ads': { es: '/servicios/google-ads', en: '/en/services/google-ads' },
  '/servicios/posicionamiento-llm': { es: '/servicios/posicionamiento-llm', en: '/en/services/llm-positioning' },
  '/en/services/llm-positioning': { es: '/servicios/posicionamiento-llm', en: '/en/services/llm-positioning' },
  '/servicios/amazon-consulting': { es: '/servicios/amazon-consulting', en: '/en/services/amazon-consulting' },
  '/en/services/amazon-consulting': { es: '/servicios/amazon-consulting', en: '/en/services/amazon-consulting' },
  '/servicios/rebranding-seo': { es: '/servicios/rebranding-seo', en: '/en/services/rebranding-seo' },
  '/servicios/branding': { es: '/servicios/branding', en: '/en/services/branding' },
  '/en/services/branding': { es: '/servicios/branding', en: '/en/services/branding' },
  '/servicios/rediseno-web': { es: '/servicios/rediseno-web', en: '/en/services/website-redesign' },
  '/en/services/website-redesign': { es: '/servicios/rediseno-web', en: '/en/services/website-redesign' },
  '/en/services/rebranding-seo': { es: '/servicios/rebranding-seo', en: '/en/services/rebranding-seo' },
  '/servicios/contenido-conversion': { es: '/servicios/contenido-conversion', en: '/en/services/content-conversion' },
  '/en/services/content-conversion': { es: '/servicios/contenido-conversion', en: '/en/services/content-conversion' },
  '/servicios/seo-tecnico': { es: '/servicios/seo-tecnico', en: '/en/services/technical-seo' },
  '/en/services/technical-seo': { es: '/servicios/seo-tecnico', en: '/en/services/technical-seo' },
  '/consultor-seo': { es: '/consultor-seo', en: '/en/seo-consultant' },
  '/en/seo-consultant': { es: '/consultor-seo', en: '/en/seo-consultant' },
  '/servicios/seo-internacional': { es: '/servicios/seo-internacional', en: '/en/services/international-seo' },
  '/en/services/international-seo': { es: '/servicios/seo-internacional', en: '/en/services/international-seo' },
  '/servicios/seo-bilingue-mercado-hispano': { es: '/servicios/seo-bilingue-mercado-hispano', en: '/en/services/hispanic-market-seo' },
  '/en/services/hispanic-market-seo': { es: '/servicios/seo-bilingue-mercado-hispano', en: '/en/services/hispanic-market-seo' },
  '/servicios/ecommerce-seo': { es: '/servicios/ecommerce-seo', en: '/en/services/ecommerce-seo' },
  '/en/services/ecommerce-seo': { es: '/servicios/ecommerce-seo', en: '/en/services/ecommerce-seo' },

  // Search Library (P3)
  '/biblioteca': { es: '/biblioteca', en: '/en/library' },
  '/en/library': { es: '/biblioteca', en: '/en/library' },
  '/biblioteca/auditoria-seo-o-estrategia-seo': { es: '/biblioteca/auditoria-seo-o-estrategia-seo', en: '/en/library/seo-audit-vs-seo-strategy' },
  '/en/library/seo-audit-vs-seo-strategy': { es: '/biblioteca/auditoria-seo-o-estrategia-seo', en: '/en/library/seo-audit-vs-seo-strategy' },
  '/biblioteca/priorizacion-seo-tecnico': { es: '/biblioteca/priorizacion-seo-tecnico', en: '/en/library/technical-seo-prioritization' },
  '/en/library/technical-seo-prioritization': { es: '/biblioteca/priorizacion-seo-tecnico', en: '/en/library/technical-seo-prioritization' },
  '/biblioteca/seo-para-ai-search': { es: '/biblioteca/seo-para-ai-search', en: '/en/library/seo-for-ai-search' },
  '/en/library/seo-for-ai-search': { es: '/biblioteca/seo-para-ai-search', en: '/en/library/seo-for-ai-search' },
  '/biblioteca/geo-aeo-y-ai-seo': { es: '/biblioteca/geo-aeo-y-ai-seo', en: '/en/library/geo-aeo-and-ai-seo' },
  '/en/library/geo-aeo-and-ai-seo': { es: '/biblioteca/geo-aeo-y-ai-seo', en: '/en/library/geo-aeo-and-ai-seo' },
  '/biblioteca/traducir-keywords-no-es-seo-internacional': { es: '/biblioteca/traducir-keywords-no-es-seo-internacional', en: '/en/library/translating-keywords-is-not-international-seo' },
  '/en/library/translating-keywords-is-not-international-seo': { es: '/biblioteca/traducir-keywords-no-es-seo-internacional', en: '/en/library/translating-keywords-is-not-international-seo' },
  '/biblioteca/seo-mercado-hispano-estados-unidos': { es: '/biblioteca/seo-mercado-hispano-estados-unidos', en: '/en/library/seo-us-hispanic-market' },
  '/en/library/seo-us-hispanic-market': { es: '/biblioteca/seo-mercado-hispano-estados-unidos', en: '/en/library/seo-us-hispanic-market' },
  '/biblioteca/ecommerce-categorias-vs-productos': { es: '/biblioteca/ecommerce-categorias-vs-productos', en: '/en/library/ecommerce-category-vs-product-pages' },
  '/en/library/ecommerce-category-vs-product-pages': { es: '/biblioteca/ecommerce-categorias-vs-productos', en: '/en/library/ecommerce-category-vs-product-pages' },
  '/biblioteca/amazon-seo-vs-amazon-ads': { es: '/biblioteca/amazon-seo-vs-amazon-ads', en: '/en/library/amazon-seo-vs-amazon-advertising' },
  '/en/library/amazon-seo-vs-amazon-advertising': { es: '/biblioteca/amazon-seo-vs-amazon-ads', en: '/en/library/amazon-seo-vs-amazon-advertising' },
  '/biblioteca/consultor-seo-o-agencia-seo': { es: '/biblioteca/consultor-seo-o-agencia-seo', en: '/en/library/seo-consultant-vs-seo-agency' },
  '/en/library/seo-consultant-vs-seo-agency': { es: '/biblioteca/consultor-seo-o-agencia-seo', en: '/en/library/seo-consultant-vs-seo-agency' },
  
  // Local SEO Hubs
  '/seo-local': { es: '/seo-local', en: '/en/local-seo' },
  '/en/local-seo': { es: '/seo-local', en: '/en/local-seo' },
  '/servicios-locales-houston': { es: '/servicios-locales-houston', en: '/en/local-services-houston' },
  '/en/local-services-houston': { es: '/servicios-locales-houston', en: '/en/local-services-houston' },
  '/servicios-locales-florida': { es: '/servicios-locales-florida', en: '/en/local-services-florida' },
  '/en/local-services-florida': { es: '/servicios-locales-florida', en: '/en/local-services-florida' },
  '/seo-local-houston': { es: '/seo-local-houston', en: '/en/local-seo-houston' },
  '/en/local-seo-houston': { es: '/seo-local-houston', en: '/en/local-seo-houston' },
  
  // Tools - Complete Mapping
  '/herramientas/seo-mega-tool': { es: '/herramientas/seo-mega-tool', en: '/en/tools/seo-mega-tool' },
  '/en/tools/seo-mega-tool': { es: '/herramientas/seo-mega-tool', en: '/en/tools/seo-mega-tool' },
  '/herramientas/contador-palabras': { es: '/herramientas/contador-palabras', en: '/en/tools/word-counter' },
  '/en/tools/word-counter': { es: '/herramientas/contador-palabras', en: '/en/tools/word-counter' },
  '/herramientas/generador-sitemap': { es: '/herramientas/generador-sitemap', en: '/en/tools/sitemap-generator' },
  '/en/tools/sitemap-generator': { es: '/herramientas/generador-sitemap', en: '/en/tools/sitemap-generator' },
  '/herramientas/corrector-ortografico': { es: '/herramientas/corrector-ortografico', en: '/en/tools/spell-checker' },
  '/en/tools/spell-checker': { es: '/herramientas/corrector-ortografico', en: '/en/tools/spell-checker' },
  '/herramientas/verificador-blacklist': { es: '/herramientas/verificador-blacklist', en: '/en/tools/blacklist-checker' },
  '/en/tools/blacklist-checker': { es: '/herramientas/verificador-blacklist', en: '/en/tools/blacklist-checker' },
  '/herramientas/analizador-seo-local-gmb': { es: '/herramientas/analizador-seo-local-gmb', en: '/en/tools/local-seo-gmb-analyzer' },
  '/en/tools/local-seo-gmb-analyzer': { es: '/herramientas/analizador-seo-local-gmb', en: '/en/tools/local-seo-gmb-analyzer' },
  '/herramientas/analizador-penalizaciones-google': { es: '/herramientas/analizador-penalizaciones-google', en: '/en/tools/google-penalization-analyzer' },
  '/en/tools/google-penalization-analyzer': { es: '/herramientas/analizador-penalizaciones-google', en: '/en/tools/google-penalization-analyzer' },
  '/herramientas/generador-metatags': { es: '/herramientas/generador-metatags', en: '/en/tools/meta-tags-generator' },
  '/en/tools/meta-tags-generator': { es: '/herramientas/generador-metatags', en: '/en/tools/meta-tags-generator' },
  '/herramientas/analizador-url': { es: '/herramientas/analizador-url', en: '/en/tools/url-analyzer' },
  '/en/tools/url-analyzer': { es: '/herramientas/analizador-url', en: '/en/tools/url-analyzer' },
  '/herramientas/densidad-palabras': { es: '/herramientas/densidad-palabras', en: '/en/tools/keyword-density' },
  '/en/tools/keyword-density': { es: '/herramientas/densidad-palabras', en: '/en/tools/keyword-density' },
  '/herramientas/generador-contenido': { es: '/herramientas/generador-contenido', en: '/en/tools/ai-content-generator' },
  '/en/tools/ai-content-generator': { es: '/herramientas/generador-contenido', en: '/en/tools/ai-content-generator' },
  '/herramientas/chatbot-personalizado': { es: '/herramientas/chatbot-personalizado', en: '/en/tools/custom-chatbot' },
  '/en/tools/custom-chatbot': { es: '/herramientas/chatbot-personalizado', en: '/en/tools/custom-chatbot' },
  '/herramientas/generador-imagenes': { es: '/herramientas/generador-imagenes', en: '/en/tools/ai-image-generator' },
  '/en/tools/ai-image-generator': { es: '/herramientas/generador-imagenes', en: '/en/tools/ai-image-generator' },
  '/herramientas/asistente-codigo': { es: '/herramientas/asistente-codigo', en: '/en/tools/code-assistant' },
  '/en/tools/code-assistant': { es: '/herramientas/asistente-codigo', en: '/en/tools/code-assistant' },
  '/herramientas/analizador-sentimientos': { es: '/herramientas/analizador-sentimientos', en: '/en/tools/sentiment-analyzer' },
  '/en/tools/sentiment-analyzer': { es: '/herramientas/analizador-sentimientos', en: '/en/tools/sentiment-analyzer' },
};

// ===== SEO PRIORITY CONFIGURATION =====
export const routePriority = {
  // Money pages - highest crawl priority
  critical: [
    '/',
    '/en',
    '/servicios',
    '/en/services',
    '/diagnostico-seo-gratis',
    '/en/free-seo-diagnosis',
    '/seo-houston',
    '/google-ads-houston',
    '/seo-the-woodlands',
    '/google-ads-the-woodlands',
    '/servicios/posicionamiento-llm',
    '/en/services/llm-positioning',
  ],
  // Authority pages - high priority
  high: [
    '/sobre-mi',
    '/en/about',
    '/casos-de-exito',
    '/en/case-studies',
    '/metodologia',
    '/en/methodology',
    '/herramientas-seo',
    '/en/seo-tools',
    '/contacto',
    '/en/contact',
    '/blog',
    '/en/blog',
  ],
  // Supporting pages - medium priority
  medium: [] as string[],
};

// Populate medium priority with remaining routes
routePriority.medium = publicRoutes.filter(r => 
  typeof r === 'string' && 
  !routePriority.critical.includes(r) && 
  !routePriority.high.includes(r) &&
  !r.includes(':slug')
);

// ===== HELPER FUNCTIONS =====

/**
 * Detect language from pathname
 */
export function detectLanguage(path: string): 'es' | 'en' {
  return path.startsWith('/en') ? 'en' : 'es';
}

/**
 * Get the alternate language URL for any path
 */
export function getLanguageAlternate(path: string, targetLang: 'es' | 'en'): string {
  // Check explicit mapping first
  const mapping = routeLanguageMap[path];
  if (mapping) {
    return mapping[targetLang];
  }
  
  // Handle dynamic routes (case studies, blog posts)
  if (path.includes('/casos-de-exito/') && targetLang === 'en') {
    return path.replace('/casos-de-exito/', '/en/case-studies/');
  }
  if (path.includes('/en/case-studies/') && targetLang === 'es') {
    return path.replace('/en/case-studies/', '/casos-de-exito/');
  }
  if (path.includes('/blog/') && !path.startsWith('/en') && targetLang === 'en') {
    return '/en' + path;
  }
  if (path.startsWith('/en/blog/') && targetLang === 'es') {
    return path.replace('/en/blog/', '/blog/');
  }
  
  // Fallback: add or remove /en prefix
  if (targetLang === 'en' && !path.startsWith('/en')) {
    return '/en' + path;
  }
  if (targetLang === 'es' && path.startsWith('/en')) {
    return path.replace('/en', '') || '/';
  }
  
  return path;
}

/**
 * Generate full URL with base domain
 */
export function getFullUrl(path: string): string {
  return `${BASE_URL}${path}`;
}

/**
 * Get canonical URL for a path (always non-trailing slash)
 */
export function getCanonicalUrl(path: string): string {
  const cleanPath = path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
  return `${BASE_URL}${cleanPath}`;
}

/**
 * Get hreflang URLs for a path
 */
export function getHreflangUrls(path: string): { es: string; en: string; xDefault: string } {
  const esPath = getLanguageAlternate(path, 'es');
  const enPath = getLanguageAlternate(path, 'en');
  
  return {
    es: getFullUrl(esPath),
    en: getFullUrl(enPath),
    xDefault: getFullUrl(esPath), // Spanish is default
  };
}

/**
 * Fuente ÚNICA de hreflang (SiteHead en cliente + sitemap en build).
 *
 * Un alternate solo existe cuando:
 *  - la ruta tiene par declarado en `routeLanguageMap` (nunca el fallback de
 *    añadir "/en"),
 *  - ambas URLs son indexables (por defecto: están en el sitemap),
 *  - no son la misma URL,
 *  - el documento ES no está pendiente de traducción real.
 *
 * `isIndexable` permite ampliar el conjunto con las URLs dinámicas que el
 * build descubre (casos y posts publicados).
 */
/**
 * Par ES/EN de las URLs dinámicas con equivalente real: solo los casos de
 * estudio públicos, que existen con el mismo slug en ambos idiomas.
 */
function getDynamicLanguagePair(path: string): { es: string; en: string } | null {
  const es = '/casos-de-exito/';
  const en = '/en/case-studies/';
  const slug = path.startsWith(en)
    ? path.slice(en.length)
    : path.startsWith(es)
      ? path.slice(es.length)
      : null;
  if (!slug || slug.includes('/')) return null;
  if (!publicCaseStudies.some((c) => c.slug === slug)) return null;
  return { es: `${es}${slug}`, en: `${en}${slug}` };
}

export function getReciprocalAlternates(
  path: string,
  isIndexable: (p: string) => boolean = (p) => sitemapRoutes.includes(p),
): { es?: string; en?: string; xDefault?: string } {
  const mapping = routeLanguageMap[path] ?? getDynamicLanguagePair(path);
  if (!mapping) return {};

  const dynamicPair = !routeLanguageMap[path];
  const esPath = mapping.es;
  const enPath = mapping.en;
  // Las URLs dinámicas (casos publicados) no están en `sitemapRoutes`;
  // su reciprocidad ya quedó verificada al construir el par.
  if (dynamicPair) {
    return { es: esPath, en: enPath, xDefault: esPath };
  }
  if (esPath === enPath) return {};
  if (!isIndexable(esPath) || !isIndexable(enPath)) return {};

  const esAwaiting = Boolean(legalEsAwaitingTranslation[esPath]);

  return {
    es: esAwaiting ? undefined : esPath,
    en: enPath,
    xDefault: esAwaiting ? enPath : esPath,
  };
}

/**
 * Get SEO priority for sitemap
 */
export function getRoutePriority(path: string): number {
  if (routePriority.critical.includes(path)) return 1.0;
  if (routePriority.high.includes(path)) return 0.8;
  if (routePriority.medium.includes(path)) return 0.6;
  return 0.5;
}

/**
 * Get change frequency for sitemap
 */
export function getChangeFrequency(path: string): 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never' {
  if (path === '/' || path === '/en') return 'daily';
  if (path.includes('/blog')) return 'daily';
  if (routePriority.critical.includes(path)) return 'weekly';
  if (routePriority.high.includes(path)) return 'weekly';
  return 'monthly';
}

// ===== LLM OPTIMIZATION: PAGE METADATA =====
export interface PageSeoConfig {
  title: { es: string; en: string };
  description: { es: string; en: string };
  keywords: string[];
  expertise: string[];
  targetAudience: { es: string; en: string };
  priority: 'critical' | 'high' | 'medium' | 'low';
  contentType: 'service' | 'article' | 'tool' | 'guide' | 'legal' | 'hub';
}

export const pageSeoConfigs: Record<string, PageSeoConfig> = {
  '/': {
    title: { 
      es: 'Luis ROC | Consultor SEO Houston TX - Experto Marketing Digital Hispano',
      en: 'Luis ROC | SEO Consultant Houston TX - Hispanic Digital Marketing Expert'
    },
    description: {
      es: 'Consultor SEO especializado en negocios hispanos en Houston. Reunión inicial gratuita de 30 minutos. ☎ Llama ahora.',
      en: 'SEO consultant specialized in Hispanic businesses in Houston. Free 30-minute initial consultation. ☎ Call now.'
    },
    keywords: ['SEO Houston', 'consultor SEO', 'marketing digital hispano', 'Google Ads Houston'],
    expertise: ['SEO', 'SEM', 'Google Ads', 'Local SEO', 'LLM Positioning'],
    targetAudience: { es: 'Empresarios hispanos en Houston', en: 'Hispanic business owners in Houston' },
    priority: 'critical',
    contentType: 'hub'
  },
  '/diagnostico-seo-gratis': {
    title: {
      es: 'Reunión inicial gratuita de 30 minutos | Luis ROC',
      en: 'Free 30-minute initial consultation | Luis ROC'
    },
    description: {
      es: 'Agenda una reunión inicial gratuita de 30 minutos para revisar qué necesita tu empresa y determinar posibles siguientes pasos.',
      en: 'Get a free professional SEO diagnosis. Technical, on-page and competitor analysis. Find out why you\'re not ranking on Google. Book your session now.'
    },
    keywords: ['reunión inicial gratuita 30 minutos', 'consultoría SEO', 'consultor SEO Houston'],
    expertise: ['SEO Audit', 'Technical SEO', 'Competitor Analysis'],
    targetAudience: { es: 'Negocios que quieren mejorar su posicionamiento', en: 'Businesses looking to improve their rankings' },
    priority: 'critical',
    contentType: 'service'
  },
  '/servicios/posicionamiento-llm': {
    title: {
      es: 'Posicionamiento LLM | Aparece en ChatGPT, Claude y Perplexity - Luis ROC',
      en: 'LLM Positioning | Rank in ChatGPT, Claude and Perplexity - Luis ROC'
    },
    description: {
      es: 'Servicio pionero de posicionamiento en LLMs. Optimiza tu presencia en ChatGPT, Claude, Perplexity y otros asistentes IA. El SEO del futuro está aquí.',
      en: 'Pioneer LLM positioning service. Optimize your presence in ChatGPT, Claude, Perplexity and other AI assistants. The future of SEO is here.'
    },
    keywords: ['posicionamiento LLM', 'SEO ChatGPT', 'optimización IA', 'LLM positioning'],
    expertise: ['LLM Positioning', 'AI Search Optimization', 'Structured Data'],
    targetAudience: { es: 'Empresas innovadoras', en: 'Innovative businesses' },
    priority: 'critical',
    contentType: 'service'
  },
};

// Export for use in components
export { BASE_URL };
